import { applyCoOwnerMenuPolicyToSidebarTree } from '@/helpers/coOwnerSidebarMenu';

export const SIDEBAR_MENU_UPDATED_EVENT = 'sidebar-menu-updated';

export function notifySidebarMenuUpdated() {
    window.dispatchEvent(new CustomEvent(SIDEBAR_MENU_UPDATED_EVENT));
}

export async function loadSidebarModuleList() {
    const userId = localStorage.getItem('userId');
    const companyId = localStorage.getItem('companyId');
    const loginSource = localStorage.getItem('loginSource') || '';
    const { default: moduleSidebarService } = await import('@/service/moduleSidebarService');
    const response = await moduleSidebarService.GetUserSidebarMenus(
        userId,
        companyId,
        '00Test',
        loginSource
    );
    const data = response?.data || {};
    const modules = Array.isArray(data.menus)
        ? data.menus
        : (Array.isArray(data.Menus) ? data.Menus : []);
    const policyApplied = await applyCoOwnerMenuPolicyToSidebarTree(modules);
    const hasCustom = data.hasCustomConfiguration === true || data.HasCustomConfiguration === true;
    if (!hasCustom) {
        return policyApplied;
    }
    const selectedIds = data.selectedMenuIds || data.SelectedMenuIds || [];
    return filterModuleListBySelection(policyApplied, selectedIds);
}

export function normalizeModuleId(moduleId) {
    return String(moduleId || '').toLowerCase();
}

export function collectAllModuleIds(modules) {
    const ids = [];

    const walk = (items) => {
        if (!Array.isArray(items)) {
            return;
        }
        items.forEach((item) => {
            if (!item?.moduleId) {
                return;
            }
            ids.push(String(item.moduleId));
            walk(item.subModules);
            walk(item.categoryModules);
        });
    };

    walk(modules);
    return [...new Set(ids)];
}

export function filterModuleListBySelection(modules, selectedIds) {
    if (!Array.isArray(modules) || !Array.isArray(selectedIds) || selectedIds.length === 0) {
        return modules;
    }

    const selectedSet = new Set(selectedIds.map(normalizeModuleId));
    const isSelected = (moduleId) => selectedSet.has(normalizeModuleId(moduleId));

    const filterSubModules = (subs) => {
        if (!Array.isArray(subs)) {
            return null;
        }
        const filtered = subs
            .map((child) => {
                const nested = filterSubModules(child.subModules);
                if (nested?.length) {
                    return { ...child, subModules: nested };
                }
                if (isSelected(child.moduleId)) {
                    return { ...child, subModules: null };
                }
                return null;
            })
            .filter(Boolean);
        return filtered.length ? filtered : null;
    };

    const filterCategoryModules = (categories) => {
        if (!Array.isArray(categories)) {
            return null;
        }
        const filtered = categories
            .map((category) => {
                const subFiltered = filterSubModules(category.subModules);
                if (subFiltered?.length) {
                    return { ...category, subModules: subFiltered };
                }
                if (isSelected(category.moduleId)) {
                    return { ...category, subModules: null };
                }
                return null;
            })
            .filter(Boolean);
        return filtered.length ? filtered : null;
    };

    return modules
        .map((item) => {
            if (Array.isArray(item.categoryModules) && item.categoryModules.length > 0) {
                const categories = filterCategoryModules(item.categoryModules);
                if (categories?.length) {
                    return { ...item, categoryModules: categories };
                }
                if (isSelected(item.moduleId)) {
                    return { ...item, categoryModules: [] };
                }
                return null;
            }

            if (isSelected(item.moduleId)) {
                return item;
            }
            return null;
        })
        .filter(Boolean);
}

export async function applyUserSidebarMenuFilter(modules) {
    try {
        const userId = localStorage.getItem('userId');
        const companyId = localStorage.getItem('companyId');
        const loginSource = localStorage.getItem('loginSource') || '';
        const { default: moduleSidebarService } = await import('@/service/moduleSidebarService');
        const response = await moduleSidebarService.GetUserSidebarMenus(userId, companyId, '00Test', loginSource);
        const data = response?.data || {};
        if (!data.hasCustomConfiguration) {
            return modules;
        }
        return filterModuleListBySelection(modules, data.selectedMenuIds || []);
    } catch {
        return modules;
    }
}
